import { Button } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { Link, useParams } from 'react-router-dom';
import CertificateContent from './CertificateContent';
import EventsManager from './EventsManager';

function PostEventCreations() {
  const { id } = useParams();
  return (
    <div>
      <EventsManager />
      <hr />
      <CertificateContent />

      <div className="text-center my-3">
        <Link to={`/admin/events/${id}`}>
          <Button variant="success">
            <FormattedMessage id="completeAndMove" />
          </Button>
        </Link>
      </div>
    </div>
  );
}

export default PostEventCreations;
